module.exports = __webpack_public_path__ + "static/media/BigBanner.fb281bd0.jpg";